import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { CartContext } from '../context/CartContext';
import { FavoritesContext } from '../context/FavoritesContext';
import Footer from './Footer'
import SEO from '../components/SEO.jsx';
import { API_URL } from '../config/api';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function SearchPage() {
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);

  const queryParam = useQuery().get('query') || '';
  const { cartDispatch } = useContext(CartContext);
  const { favorites, favoritesDispatch } = useContext(FavoritesContext);

  useEffect(() => {
    axios.get(`${API_URL}/products`)
      .then(res => setProducts(res.data))
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    const result = products.filter(p =>
      p.title.toLowerCase().includes(queryParam.toLowerCase()) ||
      p.categorie?.toLowerCase().includes(queryParam.toLowerCase())
    );
    setFiltered(result);
  }, [queryParam, products]);

  return (
   <>
    <SEO
      title="Résultats de recherche"
      description="Recherchez parmi tous les jeux vidéo, cartes PSN et cartes iTunes disponibles sur CodeShop225."
      path="/search"
      noindex
    />
    <div className="container pro-grid">
      <h2>Résultats pour : <strong>"{queryParam}"</strong></h2>

      {filtered.length > 0 ? (
        <div className="container__searchPage">
          {filtered.map(prod => {
            const isFav = favorites.some(f => f._id === prod._id);
            return (
              <div key={prod._id} className="col-md-4 mb-4">
                <article className="pro-card">
                  <Link to={`/product/${prod._id}`} className="pro-imgWrap">
                    <img
                            src={
                              prod.img.startsWith('http')
                                ? prod.img
                                : `${API_URL}/uploads/${prod.img}`
                            }
                            alt={prod.title}
                          />
                    {prod.promotion > 0 && (
                      <span className="pro-badge">-{prod.promotion}%</span>
                    )}
                  </Link>

                  <div className="pro-info">
                    <h4 className="pro-title">{prod.title}</h4>
                    <p className="pro-meta">
                      {prod.label} • {prod.categorie} • {prod.plateforme}
                    </p>
                    {/* <p className="pro-desc">{prod.description}</p> */}

                                                   <div className="pro-footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <div className="pro-price-wrapper" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
    {prod.promotion > 0 && prod.prixOriginal > 0 ? (
      <>
        <span className="original-price" style={{ textDecoration: 'line-through', color: '#888', fontWeight: '500', fontSize: '0.95rem' }}>
          {Number(prod.prixOriginal).toLocaleString()} FCFA
        </span>
        <span className="promo-price pro-price" style={{ color: '#e53935' }}>
          {Number(prod.price).toLocaleString()} FCFA
        </span>
      </>
    ) : (
      <span className="pro-price">
        {Number(prod.prixOriginal > 0 ? prod.prixOriginal : prod.price).toLocaleString()} FCFA
      </span>
    )}
  </div>

  <div className="pro-actions">
    <button className="circle-btn" onClick={() => cartDispatch({ type: 'ADD_TO_CART', payload: prod })}>
      <i className="fa-solid fa-cart-plus" />
    </button>
  </div>
</div>
                  </div>
                </article>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-muted">Aucun produit trouvé pour "{queryParam}"</p>
      )}
     
    </div>
     {/* <Footer/> */}
   </>

  );
}